
export default {
    name: 'en-tete-bon-facture',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
        }
    },

    computed: {
        
    },

    mounted() {
    
    },

    methods: {
        
    }
}